import { render } from "./ProductQuickview.vue?vue&type=template&id=5426787d&scoped=true"
import script from "./ProductQuickview.vue?vue&type=script&lang=js"
export * from "./ProductQuickview.vue?vue&type=script&lang=js"

import "./ProductQuickview.vue?vue&type=style&index=0&id=5426787d&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5426787d"]])

export default __exports__